import type { MutationHookOptions } from '@apollo/client'
import {
  UpsertTrainingSubsidyDocument,
  UpsertTrainingSubsidyMutation,
  UpsertTrainingSubsidyMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  UpsertTrainingSubsidyMutation,
  UpsertTrainingSubsidyMutationVariables
>

export const useUpsertTrainingSubsidy = (options?: Options) => {
  const [upsertTrainingSubsidy, { loading }] = useMutation(UpsertTrainingSubsidyDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.upsertSubsidyTrainingsTraining,
  })

  return {
    loading,
    upsertTrainingSubsidy(variables: UpsertTrainingSubsidyMutationVariables) {
      return upsertTrainingSubsidy({
        variables,
      })
    },
  }
}
